import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import type { TranscriptionApi } from "@/Modules/Models/Api/User";
import type { Transcription } from "@/Modules/Models/Domain/User";

import { camel } from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const TranscriptionTransformer: TransformerExtended<Transcription, TranscriptionApi> = {
  ...DefaultTransformerGenerator<Transcription, TranscriptionApi>(),

  toDomain(input: TranscriptionApi) {
    return camel<TranscriptionApi, Transcription>(input);
  },
};

export type TranscriptionTransformerType = TransformerExtended<Transcription, TranscriptionApi>;

export default TranscriptionTransformer;
